export namespace SoundConstants {
    export const ACTIVE_BUTTON = "ACTIVE_BUTTON";
    export const BOOSTER_BRUSH = "BOOSTER_BRUSH";
    export const BOOSTER_NEEDLE = "BOOSTER_NEEDLE";
    export const BOOSTER_BUCKET = "BOOSTER_BUCKET";
    export const OPEN_DESCRIPTION = "OPEN_DESCRIPTION";
    export const THROW_THE_PAGE = "THROW_THE_PAGE";
    export const UNACTIVE_BUTTON = "UNACTIVE_BUTTON";
    export const WIN_SCREEN = "WIN_SCREEN";
    export const YARN_IN_THE_FOREST = "YARN_IN_THE_FOREST";
}
